import { apiCommon } from 'lib/utils/axios';

export const checkPartnerKey = partnerKey => apiCommon.get(`check-partner-key/${partnerKey}`);
export const getLocale = () => apiCommon.get('locale');

export default {
  checkPartnerKey,
  getLocale,
};
